import apiClient from '../lib/apiClient'

export const storyService = {
  async getStories(params = {}) {
    const response = await apiClient.get('/api/stories', { params })
    if (params.page !== undefined || params.limit !== undefined) {
      return response.data
    }
    return response.data.data || response.data
  },

  async getStory(id) {
    const response = await apiClient.get(`/api/stories/${id}`)
    return response.data.data || response.data
  },

  async getStoryThreads(storyId, params = {}) {
    const response = await apiClient.get(`/api/stories/${storyId}/threads`, { params })
    return response.data
  },

  async getBeats(threadId, params = {}) {
    const response = await apiClient.get(`/api/story_threads/${threadId}/beats`, { params })
    return response.data
  },

  async getCharacter(id) {
    const response = await apiClient.get(`/api/characters/${id}`)
    return response.data.data || response.data
  },

  async getStoryDocuments(storyId) {
    const response = await apiClient.get(`/api/stories/${storyId}/documents`, {
      params: { player_visible: true },
    })
    return response.data.data || response.data
  },
}
